import React, { useCallback } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import {
  ControlLabel,
  FormGroup,
  ButtonGroup
} from 'react-bootstrap'
import {
  ViewBody
} from 'components/Sidebar'
import {
  ListItem
} from 'components/List'
import KanBoIcon from 'components/KanBoIcon'
import Button from 'components/Button'
import User from 'components/ControlledUser'
import withLeftSidebar from 'components/Sidebar/withLeftSidebar'
import AddUserToLayout from '../AddUserToLayout'
import AddUserGroup from '../AddUserGroup'
import UserGroup from 'routes/Board/Sidebar/UserGroups/UserGroup'

export function PermissionGroup ({
  layoutId,
  permissionLevel,
  title,
  userGroups,
  users,
  isLoaded,

  permission,

  requestRemoveUserFromLayout,
  requestSetUserGroupPermissionInHomeLayout,

  leftSidebar
}) {
  const handleAddUserClick = useCallback(
    () => {
      leftSidebar.push(() => <AddUserToLayout layoutId={layoutId} permissionLevel={permissionLevel} />)
    },
    [layoutId, permissionLevel, leftSidebar]
  )

  const handleAddUserGroupClick = useCallback(
    () => {
      leftSidebar.push(() => <AddUserGroup layoutId={layoutId} permissionLevel={permissionLevel} />)
    },
    [layoutId, permissionLevel, leftSidebar]
  )

  return (
    <FormGroup>
      <ViewBody>
        <ControlLabel>{title}</ControlLabel>
        {permission.owner &&
          <div className='m-b-10'>
            <ButtonGroup>
              <Button
                icon={<KanBoIcon name='kanbo-16-plus' />}
                onClick={handleAddUserClick}
              >
                <FormattedMessage id='DESK_ADD_USER' />
              </Button>
              <Button
                icon={<KanBoIcon name='kanbo-16-plus' />}
                onClick={handleAddUserGroupClick}
              >
                <FormattedMessage id='DESK_ADD_USER_GROUP' />
              </Button>
            </ButtonGroup>
          </div>
        }
      </ViewBody>
      <ul className='list-group'>
        {userGroups.map(userGroup =>
          <ListItem
            key={userGroup.Id}
            borderedIcon
            menu={permission.owner ? [{
              icon: <KanBoIcon fixedWidth name='kanbo-16-remove-responsible' />,
              title: <FormattedMessage id='REMOVE' />,
              onClick: () => {
                requestSetUserGroupPermissionInHomeLayout({
                  layoutId,
                  userGroupId: userGroup.Id,
                  permissionLevel: 0
                })
              }
            }] : undefined}
            icon={<KanBoIcon name='kanbo-16-members' />}
            onClick={() => {
              leftSidebar.push(() => <UserGroup id={userGroup.Id} />)
            }}
          >
            {userGroup.Name}
          </ListItem>
        )}
        {users.map(({ Id }) =>
          <User
            listItem
            key={Id}
            id={Id}
            defaultMenu
            presence
            menu={permission.owner ? [{
              icon: <KanBoIcon fixedWidth name='kanbo-16-remove-responsible' />,
              title: <FormattedMessage id='REMOVE' />,
              onClick: () => {
                requestRemoveUserFromLayout({ layoutId, userId: Id })
              }
            }] : undefined}
          />
        )}
        {(
          isLoaded &&
          userGroups.length === 0 &&
          users.length === 0
        ) &&
          <ViewBody>
            <FormattedMessage id='DESK_PERMISSION_GROUP_EMPTY' />
          </ViewBody>
        }
      </ul>
    </FormGroup>
  )
}

PermissionGroup.propTypes = {
  layoutId: PropTypes.number.isRequired,
  permissionLevel: PropTypes.number.isRequired,
  title: PropTypes.element.isRequired,
  userGroups: PropTypes.array.isRequired,
  users: PropTypes.array.isRequired,
  isLoaded: PropTypes.bool.isRequired,

  permission: PropTypes.object.isRequired,

  requestRemoveUserFromLayout: PropTypes.func.isRequired,
  requestSetUserGroupPermissionInHomeLayout: PropTypes.func.isRequired,

  leftSidebar: PropTypes.object.isRequired,
}

export default withLeftSidebar(PermissionGroup)
